<template>
  <div>
    <!-- 判断是否有二级菜单 -->
    <el-submenu v-if="item.children && item.children.length" :index="navIndex">
      <!-- 一级菜单 -->
      <template slot="title">
        <span class="MenuIcon">
          <font-awesome-icon :icon="item.menuIconArray" />
        </span>
        <span>{{ item.menuName }}</span>
      </template>
      <!-- 二级菜单 -->
      <el-menu-item-group>
        <el-menu-item v-for="(subItem,i) in item.children" :key="navIndex+'-'+i" :index="'/'+subItem.menuPath" :route="{path: subItem.menuPath}"  @click="clickMenu(subItem)">
          <span class="MenuIcon">
          </span>
          <span slot="title">{{subItem.menuName}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <!-- 如果没有直接渲染 -->
    <el-menu-item v-else :index="'/'+item.menuPath" :route="{path: item.menuPath}" :default-active="onRoutes" @click="clickMenu(item)">
      <template slot="title">
        <span class="MenuIcon"><font-awesome-icon :icon="item.menuIcon" /></span>
        <span>{{ item.menuName }}</span>
      </template>
    </el-menu-item>
  </div>
</template>

<script>
export default {
  name: 'NavBarItem',
  props: ['item', 'navIndex'],
  data () {
    return {
      list: [
      ]
    }
  },
  mounted () {
    this.onRoutes()
  },
  methods: {
    onRoutes () {
      return this.$route.path
    },
    clickMenu (val) {
      let result = this.$store.state.tags.findIndex(item => item.menuName === val.menuName)
      let len = this.$store.state.tags.length
      // eslint-disable-next-line no-unused-expressions
      if (result === -1 && len === 11) {
        this.$message({
          message: '标签最大显示10个',
          type: 'warning'
        })
        return
      }
      this.$store.commit('pushtags', val)
      console.log(val)
      console.log('----------------111-----------------------')
      console.log(this.$store.state.tags)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/NavBarItem.vue